<script setup lang="ts">
interface Props {
  label: string;
  disabled?: boolean;
}

//#region props
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});
//#endregion
</script>

<template>
  <div
    :class="[
      'ui-filter-item',
      {'ui-filter-item_disabled': props.disabled},
    ]"
  >
    <UiLabel
      :label="$t(label)"
      bold
    />
    <slot />
  </div>
</template>

<style lang="scss">
.ui-filter-item {
  padding: 10px 0;
  margin: 0 10px;
  color: var(--text-body);
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-divider);
  height: 54px;
  &:last-child{
    border-bottom: none;
  }

  &_disabled {
    pointer-events: none;
    opacity: .5;
  }
}
</style>
